import { Button } from "@design-system/shadcn";
import { X } from "lucide-react";
import React from "react";

import { useFilters } from "../filters-provider";

interface FilterBarClearProps {
  label: string;
  className?: string;
}

function FilterBarClear({ label, className }: FilterBarClearProps) {
  const { hasActiveFilters, clearAll } = useFilters();

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={clearAll}
      className={className}
    >
      <X aria-hidden />
      {label}
    </Button>
  );
}

export { FilterBarClear };
export type { FilterBarClearProps };
